import { getCharWidth } from './getCharWidth'

export const OFFSET_SIZE = 4 // the actual size is always -4 pixel when render with ref in web
export const MAX_OVERFLOW_PLACEHOLDER_SIZE = getCharWidth('+99') // max space needed to render overflow placeholder
